import React, { useState } from "react";
import { mediaExtensions } from "../constant/constant";

import mp3Icon from "../../assets/images/MediaIcon/mp3.png";
import pdfIcon from "../../assets/images/MediaIcon/pdf.png";
import wordIcon from "../../assets/images/MediaIcon/word.png";
import excelIcon from "../../assets/images/MediaIcon/excel.png";
import defaultIcon from "../../assets/images/MediaIcon/file.png";
import pptIcon from "../../assets/images/MediaIcon/powerpoint.png";
import csvIcon from "../../assets/images/MediaIcon/csv.png";
import videoIcon from "../../assets/images/MediaIcon/video.png";


const extensionIconMap = {
  image: null,
  video: videoIcon,
  audio: mp3Icon,
  pdf: pdfIcon,
  word: wordIcon,
  excel: excelIcon,
  ppt: pptIcon,
  csv: csvIcon,
  code: defaultIcon,
};

// Get file category based on extension
const getFileCategory = (filename) => {
  const ext = "." + filename.split(".").pop().toLowerCase();

  for (const [type, extensions] of Object.entries(mediaExtensions)) {
    if (extensions.includes(ext)) {
      return type;
    }
  }

  return "other";
};

const ViewFile = ({ file, removeHandler = () => { }, progress }) => {
  const [uploadError] = useState(null);

  const formatBytes = (bytes) => {
    if (!bytes) return;
    const units = ["B", "KB", "MB", "GB", "TB"];
    let index = 0;
    while (bytes >= 1024 && index < units.length - 1) {
      bytes /= 1024;
      index++;
    }
    return `${bytes?.toFixed(2)} ${units[index]}`;
  };

  const fileCategory = getFileCategory(file?.name);

  const icon = extensionIconMap[fileCategory];

  return (
    <div className="p-2 bg-denim/10 rounded-lg border border-denim/20 shadow text-center flex flex-col items-center justify-between h-36 transition hover:shadow-md">
      {fileCategory === "image" ? (
        <img
          src={URL.createObjectURL(file)}
          alt="preview"
          className="w-10 h-10 object-cover rounded mb-1"
        />
      ) : (
        <img
          src={icon || defaultIcon}
          alt="file-icon"
          className="w-8 h-8 object-contain mb-1"
        />
      )}

      <div className="w-full text-[12px] font-medium truncate" title={file?.name}>
        {file?.name}
      </div>
      <div className="text-[10px] text-gray-500">{formatBytes(file?.size)}</div>

      <div className="w-full bg-white rounded h-[5px] mt-1">
        <div
          className="bg-denim h-[5px] rounded transition-all"
          style={{ width: `${progress}%` }}
        ></div>
        {uploadError && <p className="text-xs text-rose-500">{uploadError}</p>}
      </div>

      <div className="flex items-center justify-between w-full mt-1">
        <span className="text-[10px] text-gray-800">{progress}%</span>
        {progress < 1 && (
          <button
            type="button"
            className="text-[10px] text-red-500 hover:text-red-600"
            onClick={removeHandler}
          >
            <i className="fa-regular fa-trash-can"></i>
          </button>
        )}
      </div>
    </div>

  );
};

export default ViewFile;
